import { NavLink } from 'react-router';
import { useTranslation } from 'react-i18next';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import { logoutFromTarget } from '@/generated/client/driveon-api/driveon-api';
import { DriveOnTargetDto as Target } from '@/generated/model';
import { DriveOnDriverInputInputType as InputType } from '@/generated/model/driveOnDriverInputInputType';
import { Button } from '@mui/material';
import { useDriveOnContext } from '@/contexts/DriveOnContext';

import './Active.css';

export function ActiveVehicle() {
  const { t } = useTranslation();
  const driveOnCtx = useDriveOnContext();

  function Target({ target }: { target: Target }) {
    return (
      <>
        <div>
          {target.name} {target.userSpecifiedDescription && <>({target.userSpecifiedDescription})</>}
        </div>
        <div className="button-container">
          <NavLink className="link" to="/menetlevel/jarmuvalaszto">
            <Button variant="contained" className="button">{t('home.activevehicle.change')}</Button>
          </NavLink>
          <Button variant="contained" className="button" onClick={unassignTarget}>
            {t('home.activevehicle.close')}
          </Button>
        </div>
      </>
    );
  }

  function NoTarget() {
    return (
      <>
        <div>{msg()}</div>
        <div className="button-container">
          <NavLink className="link" to="/menetlevel/jarmuvalaszto">
            <Button variant="contained" className="button">{t('home.activevehicle.choose')}</Button>
          </NavLink>
        </div>
      </>
    );
  }

  async function unassignTarget() {
    if (driveOnCtx.target) {
      const response = await logoutFromTarget().catch((error) =>
        console.log('unassignTarget(): Api failed: logoutFromTarget', error)
      );

      if (response && response.status == 200) {
        console.log('unassignTarget(): Api called: logoutFromTarget');
        driveOnCtx.setInputType(InputType.TARGET_UNASSIGNED);
        driveOnCtx.setTarget(undefined);
        driveOnCtx.setLogbook(undefined);
        driveOnCtx.setTask(undefined);
      }
    }
  }

  function msg() {
    if (driveOnCtx.inputType === InputType.TARGET_UNASSIGNED) {
      return t('home.activevehicle.unassigned');
    } else if (driveOnCtx.inputType === InputType.MIDNIGHT_CLEANUP) {
      return t('home.activevehicle.midnight');
    } else if (driveOnCtx.inputType === InputType.KICKED) {
      return t('home.activevehicle.kicked');
    } else {
      return t('home.activevehicle.novehicle');
    }
  }

  return (
    <div className="active">
      <div className="title">
        <LocalShippingIcon className="icon" />
        <span>{driveOnCtx.target?.egs ? t('home.activevehicle.egs') : t('home.activevehicle.title')}</span>
      </div>
      {driveOnCtx.target ? <Target target={driveOnCtx.target} /> : <NoTarget />}
    </div>
  );
}
